/** Redefinição de senha (SPEC-IDN-012).
 *
 * As duas chamadas são públicas. O pedido responde `202` exista ou não a conta
 * — a interface não tem o que interpretar aqui, e é essa ausência de sinal que
 * impede a tela de virar um oráculo de e-mails cadastrados.
 */

import { http } from "@/lib/http";

export async function pedirRedefinicao(email: string): Promise<void> {
  await http.post<{ detail: string }>("/auth/password-reset", { email });
}

export async function concluirRedefinicao(token: string, password: string): Promise<void> {
  // `undefined` e não `void`: a rota responde 204 e o cliente devolve
  // `undefined` — `void` como argumento de tipo é inválido em posição de valor.
  await http.post<undefined>(`/auth/password-reset/${encodeURIComponent(token)}`, { password });
}
